import { Text } from '@react-three/drei'
import { s3PublicStoragePrefix } from '../../../utility'
import { Item } from './types'
import { useLoader } from '@react-three/fiber'
import { TextureLoader } from 'three/src/loaders/TextureLoader'
import arrow from '../../../assets/image/cube/kandi-test/arrow.png'

const KandiTile: React.FC<{ item: Item }> = ({ item }) => {
  const fontBolder = `${s3PublicStoragePrefix}custom-static-assets/fonts/countdownFontBolder.ttf`
  const fontBold = `${s3PublicStoragePrefix}custom-static-assets/fonts/countdownFontBold.ttf`

  const images = useLoader(TextureLoader, [item.kandi.outline, arrow])

  const maxSplitNumber = 13

  const isLonglastname = item.kandi.lastname.includes('-')
    ? item.kandi.lastname.length > maxSplitNumber + 1
    : item.kandi.lastname.length > maxSplitNumber

  const isSmallNameEnabled = () => {
    if (item.kandi.lastname.includes('-')) {
      const split = item.kandi.lastname.split('-')
      if (split[0].length >= maxSplitNumber + 2 && split[1].length >= maxSplitNumber + 2) {
        return true
      } else {
        return item.kandi.lastname.length > maxSplitNumber - 2
      }
    } else if (item.kandi.lastname.length >= maxSplitNumber) {
      return true
    } else {
      return false
    }
  }

  const getLastnameSplit = () => {
    if (isLonglastname) {
      if (item.kandi.lastname.includes('-')) {
        const split = item.kandi.lastname.split('-')
        if (split[0].length <= maxSplitNumber + 2 && split[1].length <= maxSplitNumber + 2) {
          return [`${split[0]}-`, split[1]]
        }
      } else {
        return [item.kandi.lastname]
      }
    }
    return [item.kandi.lastname]
  }

  return (
    <group position={[0.501, 0, 0]} rotation={[-Math.PI / 2, 0, Math.PI / 2]}>
      <mesh position={[0, -0.0001, 0]} rotation={[Math.PI / 2, 0, 0]}>
        <planeGeometry attach="geometry" args={[1, 1]} />
        <meshBasicMaterial color="#b9b9b9" attach="material" map={images[0]} transparent premultipliedAlpha />
      </mesh>
      <mesh
        renderOrder={1}
        position={[
          -0.37,
          -0.001,
          isLonglastname && getLastnameSplit().length > 1 ? (isSmallNameEnabled() ? -0.01 : 0.05) : isSmallNameEnabled() ? -0.07 : -0.05,
        ]}
        rotation={[Math.PI / 2, 0, 0]}
      >
        <planeGeometry attach="geometry" args={[0.15, 0.1]} />
        <meshBasicMaterial attach="material" map={images[1]} transparent premultipliedAlpha />
      </mesh>
      <Text
        font={fontBold}
        fontSize={0.07}
        fontWeight={300}
        color="#ffffff"
        anchorX={0.45}
        // anchorY={isLonglastname && getLastnameSplit().length > 1 ? 0.03 : 0.15}
        anchorY={getLastnameSplit().length > 1 ? (isSmallNameEnabled() ? 0.1 : 0.03) : 0.15}
        position={[0, -0.001, 0]}
        rotation={[Math.PI / 2, 0, 0]}
        renderOrder={1}
      >
        Für Dich vor Ort:
      </Text>
      <Text
        font={fontBolder}
        fontSize={isSmallNameEnabled() ? 0.11 : 0.13}
        fontWeight={700}
        color="#ffffff"
        anchorX={0.45}
        anchorY={getLastnameSplit().length > 1 ? (isSmallNameEnabled() ? 0.18 : 0.11) : 0.23}
        position={[0, -0.001, 0]}
        rotation={[Math.PI / 2, 0, 0]}
        renderOrder={1}
      >
        {item.kandi.firstname}
      </Text>
      {getLastnameSplit().map((lastname, index) => (
        <Text
          key={index}
          font={fontBolder}
          fontSize={isSmallNameEnabled() ? 0.11 : 0.13}
          fontWeight={700}
          color="#ffffff"
          anchorX={0.45}
          // anchorY={(isLonglastname && getLastnameSplit().length > 1 ? 0.23 : 0.35) + index * 0.12}
          anchorY={(getLastnameSplit().length > 1 ? (isSmallNameEnabled() ? 0.28 : 0.23) : 0.35) + index * 0.1}
          position={[0, -0.001, 0]}
          rotation={[Math.PI / 2, 0, 0]}
          renderOrder={1}
        >
          {lastname}
        </Text>
      ))}
    </group>
  )
}

export default KandiTile
